var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thermique__evs"},[_c('a',{attrs:{"href":_vm.ev.link}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.ev.img)}})]),_c('div',{domProps:{"innerHTML":_vm._s((_vm.description + " " + _vm.linkToProduct))}})])}
var staticRenderFns = []

export { render, staticRenderFns }